export default function toSnakeCase(str) {
  return str
    .split(' ')
    .map(word => word.toLowerCase())
    .join('_');
}
